import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    impuestos: false,
    controller: 'pagos',

    pagos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    filtroFechaDocumentos: false,
    proveedor: null,
    sortByDescending: false,

    list: [],
    rptPagos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.impuestos = false;

        state.pagos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.filtroFechaDocumentos = false;
        state.proveedor = null;
        state.sortByDescending = true;
    },

    'INICIALIZAR_PAGOS' (state, impuestos) {
        if (state.impuestos != impuestos) {
            state.fechaDesde =  moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
            state.fechaHasta =  moment(new Date()).format('YYYY-MM-DD');
            state.filtroFechaDocumentos = false;
            state.proveedor = null;
            state.paginaActual = 1;
        }

        state.impuestos = impuestos;
        if (impuestos) {
            state.controller = 'pagos-impuestos';
        } else {
            state.controller = 'pagos';
        }

        state.pagos = [];
    },
    'SET_PAGOS' (state, pagos) {
        state.pagos = pagos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, list) {
        state.list = list;
        // console.log(state.list);
    },

    'INICIALIZAR_RPT_PAGOS' (state) {
        state.rptPagos = [];
    },
    'SET_RPT_PAGOS' (state, rptPagos) {
        state.rptPagos = rptPagos;
    },
};

const getters = {
    getField,

    list(state) {
        return state.list;
    },
    rptPagos(state) {
        return state.rptPagos;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPagos ( { commit, state }, impuestos ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PAGOS', impuestos);
            
            let queryString = '';
            
            if (!(/true/i).test(state.impuestos)) {
                queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            } else {
                if ((/true/i).test(state.filtroFechaDocumentos)) {
                    queryString = '?fechaDocumentosDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaDocumentosHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                } else {
                    queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                }
            }
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
            
            apiAxios.get(state.controller + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PAGOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, pagoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(state.controller + '/' + pagoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getList ( { commit, state }, impuestos ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST', impuestos);
            
            let queryString = '';
            
            if (!(/true/i).test(state.impuestos)) {
                queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            } else {
                if ((/true/i).test(state.filtroFechaDocumentos)) {
                    queryString = '?fechaDocumentosDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaDocumentosHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                } else {
                    queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                }
            }
            
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
            
            apiAxios.get(state.controller + queryString)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPagos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PAGOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.proveedorId != 0) {
                queryString += '&proveedorId=' + params.proveedorId;
            }

            apiAxios.get('pagos/reporte' + queryString)
                .then(res => {
                    commit('SET_RPT_PAGOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}